import {useFormikContext} from 'formik'
import {FC} from 'react'

import {FormButton} from '@/components/common/form/FormButton'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'
import {TrademarkTypeValue, VerificationTrademarkTypeValue} from '@/utils/constants'

import {TrademarkDefiniton} from '../trademark/TrademarkDefinition'
import {TrademarkSelection} from '../trademark/TrademarkSelection'
import {TrademarkServiceDescription} from '../trademark/TrademarkServiceDescription'
import {TrademarkVerificationFields} from '../types'

export const TrademarkStep: FC<React.PropsWithChildren<unknown>> = () => {
  const {t} = useTranslation()
  const {continueButtonText} = useTrademarkVerificationContent()
  const {values, errors} = useFormikContext<TrademarkVerificationFields>()

  const isButtonDisabled = !!errors.file

  return (
    <>
      <TrademarkSelection />
      <TrademarkDefiniton
        type={values.type as TrademarkTypeValue}
        typeValue={values.typeValue as VerificationTrademarkTypeValue}
      />
      <TrademarkServiceDescription />
      <FormButton
        dataTest="continueButton"
        text={t(continueButtonText)}
        isInactive={isButtonDisabled}
      />
    </>
  )
}
